import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from './i18n.service'; // Importa el servicio

/**
 * A pipe that translates text according to the provided namespace and parameters.
 * Utilizes the `I18nService` for translation.
 */


@Pipe({
    name: 'sitTranslate'
})
export class I18nPipe implements PipeTransform {

    /**
    * Creates an instance of I18nPipe.
    * @param translator An instance of `I18nService` to handle the translation logic.
    */
    constructor(private translator: I18nService) { }

    /**
     * @precondition The translation files must be loaded and available to the `I18nService`
     * before attempting to use this pipe for translation.
     * 
     * Transforms the given value into a translated string.
     * 
     * @param value The value to be translated. Typically, this is a key in the translation files.
     * @param args Additional arguments where:
     *        - The first argument is the namespace to be used in translation.
     *        - The second argument is an object containing interpolation parameters.
     * @returns The translated string.
     * 
     * @example
     * // In an Angular template, the pipe can be used as follows:
     * // Assuming 'namespace' is a variable in the component that defines the translation namespace,
     * // and 'titlePanel' is the variable containing the value to be interpolated to the variable panel.
     *      {{ 'title-panel' | sitTranslate: namespace : {'panel': titlePanel} }}
     * 
     */
    transform(value: string, ...args: any[]): string {
        if (!value) return value;
        const [namespace, interpolationParams] = args;
        return this.translator.translate(`${namespace}:${value}`, interpolationParams) || value;
    }
}